const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nickName: state => state.user.nickName,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  visitRoutes: state => state.app.visitRoutes,
  searchParams: state => state.user.searchParams,
  ingredientsParams: state => state.user.ingredientsParams,
  article: state => state.user.article,
  advise: state => state.user.advise
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js